import { produce } from "immer";
import ACTIONS from "../actions/types.actions";

const division = produce((draft, action) => {
  switch (action.type) {
    case ACTIONS.DIVISION_REQUEST:
      draft[action.key] = true;
      return draft;
    case ACTIONS.DIVISION_SUGGESTION_REQUEST:
      draft.suggestionLoading = false;
      draft.error = null;
      return draft;
    case ACTIONS.DIVISION_SUGGESTION_SUCCESS:
      draft.suggestionLoading = false;
      draft.error = null;
      return draft;
    case ACTIONS.DIVISION_SUCCESS:
      draft.loading = false;
      draft.error = null;
      draft.value = action.response;
      return draft;
    case ACTIONS.DIVISION_LIST_SUCCESS:
      draft.loading = false;
      draft.error = null;
      draft.list = action.response.list;
      draft.pagination = action.response.pagination;
      return draft;
    case ACTIONS.DIVISION_SELECTED_LIST_SUCCESS:
      draft.loading = false;
      draft.error = null;
      draft.selectedList = action.response.selectedList;
      draft.pagination = action.response.pagination;
      return draft;
    case ACTIONS.MARKET_ERROR:
      draft[action.key] = false;
      draft.error = action.error;
      return draft;
    default:
      return draft;
  }
});

export default division;
